<template>
  <div class="modal-wrapper" @click.self="$emit('close')">
    <div class="modal" @click="closeAllDDs">
      <header>
        <div>
          <span class="tms">0</span>
          <p v-if="group">
            <template v-if="group.worker"> {{ group.worker.name }} - </template>
            {{ group.name }}
          </p>
          <p v-else>ПЛАНИРАЙ ОБЕКТИ/ЧАСТИ</p>
        </div>
        <span class="tms close" @click="$emit('close')">F</span>
      </header>
      <main>
        <div class="row">
          <p>
            <strong>Период от-до на планирането</strong>
          </p>
          <p>
            <strong>Фирма / Обект</strong>
          </p>
        </div>
        <div class="row" v-for="(r, i) in rows" :key="`row-${i}`">
          <div class="period" @click.stop>
            <div class="date" @click="openDropDown(r, 'dateFrom')">
              <span class="tms">8</span>
              <p>{{ r.dateFrom | formatDateDots }}</p>
            </div>
            <div class="date" @click="openDropDown(r, 'dateTo')">
              <span class="tms">9</span>
              <p>{{ r.dateTo | formatDateDots }}</p>
            </div>
            <div class="dp" v-show="r.dd === 'dateFrom' || r.dd === 'dateTo'">
              <datepicker
                :language="bg"
                :inline="true"
                :value="
                  r.dd === 'dateFrom' || r.dd === 'dateTo' ? r[r.dd] : null
                "
                :monday-first="true"
                :minimumView="'day'"
                :maximumView="'day'"
                :full-month-name="true"
                @selected="selectDate(r, $event)"
              />
            </div>
          </div>
          <div class="object-selector" @click.stop>
            <main @click="openDropDown(r, 'object')">
              <span class="tms">"</span>
              <input
                v-model="r.search"
                :class="{ value: r.object && !r.searchFocused }"
                :placeholder="
                  r.searchFocused
                    ? 'Търсене'
                    : r.object
                    ? `${r.company.companyName} / ${r.object.objectName}`
                    : 'Планирайте част за избрания период'
                "
                @focus="$set(r, 'searchFocused', true)"
                @blur="$set(r, 'searchFocused', false)"
              />
              <span class="tms" :class="{ reversed: r.dd === 'object' }"
                >K</span
              >
            </main>
            <div class="dd" v-if="r.dd === 'object'">
              <template v-for="c in filteredCompanies(r)">
                <p class="company" :key="c._id">{{ c.companyName }}</p>
                <template v-for="o in c.objects">
                  <p class="object" :key="o._id" @click="selectObject(r, c, o)">
                    ОБЕКТ: {{ o.objectName }}
                  </p>
                </template>
              </template>
            </div>
          </div>
          <span class="tms delete" @click="deleteRow(i)" v-if="rows.length > 1"
            >b</span
          >
        </div>
        <div class="add-row" @click="addRow">
          <span class="icon">+</span>
          <p>Добавяне на ден/период</p>
        </div>
      </main>
      <footer :class="{ 'footer--groups': group }">
        <button :disabled="loading" @click="save(false)">ЗАПАЗИ</button>
        <button
          class="btn--green"
          v-if="group"
          :disabled="loading"
          @click="save(true)"
        >
          ЗАПАЗИ И ИЗПРАТИ ЗА ОДОБРЕНИЕ
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
export default {
  components: {
    Datepicker,
  },
  props: ["group", "date"],
  computed: {
    ...mapGetters(["getUser"]),
  },
  data() {
    return {
      bg,
      companies: [],
      rows: [{ dateFrom: this.date, dateTo: this.date }],
      loading: false,
    };
  },
  methods: {
    addRow() {
      this.rows.push({ dateFrom: this.date, dateTo: this.date });
    },
    closeAllDDs() {
      for (let r of this.rows) {
        this.$delete(r, "dd");
      }
    },
    openDropDown(r, dd) {
      this.closeAllDDs();
      this.$set(r, "dd", dd);
    },
    selectDate(r, d) {
      r[r.dd] = d;
      this.$delete(r, "dd");
    },
    selectObject(r, c, o) {
      this.$set(r, "company", c);
      this.$set(r, "object", o);
      this.$delete(r, "dd");
      this.$delete(r, "search");
    },
    deleteRow(i) {
      this.rows.splice(i, 1);
    },
    filteredCompanies(r) {
      const search = r.search ? r.search.toLowerCase() : "";

      return this.companies
        .map((company) => {
          const matchingObjects = company.objects
            .map((object) => {
              const objectNameMatches = object.objectName
                .toLowerCase()
                .includes(search);

              if (objectNameMatches) {
                return {
                  ...object,
                };
              } else {
                // no maches and will be removed in the filter
                return null;
              }
            })
            .filter(Boolean); // Remove null values from matching objects

          if (
            company.companyName.toLowerCase().includes(search) ||
            matchingObjects.length > 0
          ) {
            return {
              ...company,
              objects: matchingObjects.length
                ? matchingObjects
                : company.objects,
            };
          } else {
            // no maches and will be removed in the filter
            return null;
          }
        })
        .filter(Boolean); // Remove null values from the result
    },
    getCompanies() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/active`;

      if (
        !this.getUser.permissions.isSuperAdmin &&
        !this.getUser.permissions.isAdmin
      ) {
        url += `?reporterId=${this.getUser._id}`;
      }

      this.$http.get(url).then((res) => {
        this.companies = res.data;
      });
    },
    isValid() {
      const objects = [];
      for (let r of this.rows) {
        if (!r.object) {
          this.$snotify.error("Не сте избрали обект на всеки ред.");
          return;
        }

        const object = `${r.company._id}-${r.object._id}`;
        if (objects.indexOf(object) > -1) {
          this.$snotify.error("Всеки обект може да бъде избиран само веднъж");
          return;
        } else objects.push(object);
      }

      return true;
    },
    save(sendForConfirmation) {
      if (this.isValid()) {
        this.loading = true;
        let url = `${process.env.VUE_APP_BASE_URI}/planning`;
        if (this.group) url += "/group";
        if (this.group && sendForConfirmation)
          url += "?sendForConfirmation=true";

        this.$http
          .post(url, {
            group: this.group,
            rows: this.rows,
            user: this.getUser._id,
          })
          .then((res) => {
            if (res.data.existing) {
              for (let e of res.data.existing) {
                if (this.group) {
                  if (e.status === "initial") {
                    this.$snotify.error(
                      `Групата е вече планирана за ${
                        e.company.companyName
                      } -> ${
                        e.object.objectName
                      } на ${this.$options.filters.formatDate(e.date)}`
                    );
                  } else {
                    const statuses = {
                      awaiting: "изпратено за одобрение",
                      confirmed: "потвърдено",
                      reported: "потвърдено",
                    };
                    this.$snotify.error(
                      `Планирането за ${e.company.companyName} -> ${
                        e.object.objectName
                      } на ${this.$options.filters.formatDate(e.date)} е вече ${
                        statuses[e.status]
                      }`
                    );
                  }
                } else {
                  this.$snotify.error(
                    `Обектът ${e.company.companyName} -> ${
                      e.object.objectName
                    }  е вече планиран на ${this.$options.filters.formatDate(
                      e.date
                    )}`
                  );
                }
              }
              this.loading = false;
            } else {
              this.$emit("close", true);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.getCompanies();
  },
  destroyed() {},
};
</script>

<style lang="scss" scoped>
.modal {
  overflow: initial;
  max-width: 790px;
  user-select: none;
  width: calc(100% - 40px);
  header {
    align-items: center;
    background: #00408a;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    color: #fff;
    display: flex;
    height: 43px;
    justify-content: space-between;
    padding: 0 13px 0 25px;

    > div {
      align-items: center;
      display: flex;
      gap: 7px;
      .tms {
        font-size: 27px;
      }
      p {
        font-weight: 500;
        text-transform: uppercase;
      }
    }

    .close {
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  > main {
    max-height: calc(70vh - 104px);
    // overflow: auto;
    padding: 15px 25px;

    .row {
      display: grid;
      gap: 6px;
      grid-template-columns: 30% calc(70% - 16px) 16px;

      &:first-child {
        margin-bottom: 4px;
      }

      &:not(:first-child) {
        margin-top: 6px;
      }
    }

    .period {
      background: #fff;
      border: 1px solid #cecece;
      border-radius: 4px;
      display: inline-flex;
      gap: 2px;
      height: 36px;
      position: relative;

      .date {
        align-items: center;
        cursor: pointer;
        display: flex;
        height: 100%;
        font-size: 12px;
        gap: 5px;
        padding: 0 8px;
        .tms {
          color: #0057bb;
          font-size: 20px;
        }

        &:hover {
          opacity: 0.8;
        }
      }

      .dp {
        background: #fff;
        border: 1px solid #cecece;
        border-radius: 4px;
        left: 0;
        position: absolute;
        top: calc(100% + 6px);
        width: 100%;
        z-index: 1;
      }
    }

    .object-selector {
      background: #fff;
      border: 1px solid #cecece;
      border-radius: 4px;
      display: inline-flex;
      font-size: 12px;
      height: 36px;
      position: relative;
      width: 100%;

      > main {
        align-items: center;
        cursor: pointer;
        display: flex;
        gap: 9px;
        height: 100%;
        padding: 0 7px;
        width: 100%;
        > .tms:first-child {
          color: #0057bb;
          font-size: 20px;
          left: 7px;
          position: absolute;
          transform: translateY(-50%);
          top: 50%;
        }
        > .tms:last-child {
          &.reversed {
            transform: scaleY(-1);
          }
        }
        input {
          background: transparent;
          border: none;
          font-size: 12px;
          height: 100%;
          outline: none;
          padding: 0 0 0 30px;
          &::placeholder {
            color: #737373;
          }
          &.value::placeholder {
            color: #000;
          }
        }
        p {
          font-weight: 700;
          width: 100%;
          &.selected {
            line-height: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 100%;
            white-space: nowrap;
            .tms {
              font-weight: 400;
              margin: 0 10px;
              vertical-align: middle;
            }
          }
        }
      }

      .dd {
        background: #fff;
        border: 1px solid #cecece;
        border-radius: 4px;
        display: block;
        overflow: auto;
        left: 0;
        max-height: 250px;
        position: absolute;
        top: calc(100% + 3px);
        padding-left: 34px;
        padding-right: 10px;
        width: 100%;
        z-index: 1;

        p {
          padding: 5px 0;
          &.company {
            cursor: not-allowed;
            font-weight: 700;
          }
          &.object {
            cursor: pointer;
            color: #0057bb;
            font-weight: 700;
            padding-left: 1rem;
            text-decoration: underline;

            &:hover {
              opacity: 0.8;
            }
          }

          &.object {
            &::before {
              font-family: "tms";
              font-size: 10px;
              content: "M";
              margin-right: 5px;
            }
          }
        }
      }
    }

    .delete {
      align-items: center;
      color: #d58080;
      cursor: pointer;
      font-size: 14px;
      display: inline-flex;
      opacity: 0.5;
      justify-content: flex-end;
      height: 34px;
      width: 16px;

      &:hover {
        opacity: 1;
      }
    }
  }

  > footer {
    border-top: 1px solid #70707033;
    display: flex;
    padding: 12px;
    justify-content: center;
    width: calc(100% - 11px);

    &.footer--groups {
      justify-content: space-between;
    }

    button {
      background: #0057bb;
      border: none;
      border-radius: 4px;
      color: #fff;
      cursor: pointer;
      font-size: 13px;
      font-weight: 500;
      height: 36px;
      padding: 0 20px;
      min-width: 160px;
      white-space: nowrap;
      width: fit-content;

      &.btn--green {
        background: #187413;
      }
      &:disabled {
        cursor: default;
        opacity: 0.8;
      }

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .modal {
    width: calc(100% - 10px);

    > main {
      .row {
        grid-template-columns: 100%;
      }
      .period {
        border: none;
        justify-content: center;
        gap: 10px;

        .date {
          border: 1px solid #cecece;
          border-radius: inherit;
          width: 50%;
        }
      }
    }
    > footer {
      align-items: center;
      flex-direction: column;
      gap: 5px;

      button {
        width: 100%;
      }
    }
  }
}
</style>
